module.exports = __webpack_public_path__ + "img/academic.604b7c19.svg";